import { useState } from "react"
import {
    Grid,
    AppBar,
    Tabs,
    Tab,
} from "@material-ui/core"
import EventIcon from '@material-ui/icons/Event';
import HomePage from "../../Home"
import { Container } from "@material-ui/core"
import Cotizaciones from "../Cotizaciones";
import IntentoRegistro from "../IntentoRegistro";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    {children}
                </div>
            )}
        </div>
    );
}
function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
}
const VCotizaciones = () => {
    const [value, setValue] = useState(0)
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    return (
        <HomePage>
            <Container maxWidth="xl">
                <Grid container>
                    <Grid item xs={12}>
                        <h3>Cotizaciones</h3>
                    </Grid>
                    <Grid item xs={12}>
                        <AppBar position="static" color="secondary">
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons="on"
                                indicatorColor="primary"
                                aria-label="scrollable force tabs example"
                            >
                                <Tab
                                    label={`Cotizaciones`}
                                    icon={<EventIcon />}
                                    {...a11yProps(0)}
                                />
                                <Tab
                                    label={`Intento de clientes`}
                                    icon={<EventIcon />}
                                    {...a11yProps(1)}
                                />

                            </Tabs>
                        </AppBar>
                        <TabPanel value={value} index={0}>
                            <br />
                            <Cotizaciones />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <br />
                            <IntentoRegistro />
                        </TabPanel>
                    </Grid>
                </Grid>
            </Container>
        </HomePage>
    )
}
export default VCotizaciones